export enum SuccessfulStatus {
  BeforeCall = 'BeforeCall',
  Success = 'Success',
  Failed = 'Failed',
}
